// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ca6bae9d","732":"be98b1eb","977":"135f61d9"}[chunkId] + ".chunk.js";
};